// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1SGNg","rootMobile":"styles_rootMobile__1izxf"};